// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/About.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-hero-js": () => import("./../../../src/pages/Hero.js" /* webpackChunkName: "component---src-pages-hero-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("./../../../src/pages/Projects.js" /* webpackChunkName: "component---src-pages-projects-js" */),
  "component---src-pages-schedule-js": () => import("./../../../src/pages/Schedule.js" /* webpackChunkName: "component---src-pages-schedule-js" */),
  "component---src-pages-submit-js": () => import("./../../../src/pages/Submit.js" /* webpackChunkName: "component---src-pages-submit-js" */)
}

